import React from 'react';

interface FooterData {
  columns: {
    title: string;
    url?: string;
    newTab?: boolean;
    links: {
      text: string;
      url: string;
      newTab?: boolean;
      onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    }[];
  }[];
  legal: string;
}

const data: FooterData = {
  columns: [
    {
      title: 'Marketplace',
      url: '/marketplace',
      links: [
        {
          text: 'Sign Up',
          url: '/connect/signUp'
        },
        {
          text: 'Legal stuff',
          url: '#legal',
          onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            const element = document.querySelector(
              `#${(e.target as Element).getAttribute('href')?.split('#')[1]}`
            );
            element?.scrollIntoView({ behavior: 'smooth' });
          }
        }
      ]
    },
    {
      title: 'USREM Securities, LLC',
      url: 'https://www.usremsecurities.com',
      newTab: true,
      links: [
        {
          text: 'Sponsors Relations',
          url: 'mailto:contact@usremsecurities.com'
        },
        {
          text: 'Investor Relations',
          url: 'mailto:contact@usremsecurities.com'
        },
        {
          text: 'Jobs',
          url: 'mailto:jobs@usremsecurities.com'
        },
        {
          text: 'Contact Us',
          url: 'https://www.usremsecurities.com/contact/',
          newTab: true
        }
      ]
    }
  ],
  legal: `
  <p>USREM Markets LLC is a broker-dealer registered with the SEC, a member of FINRA and the SIPC, and operates this site as an Alternative Trading System (“ATS”).</p>
  <p>Private placements on usremsecurities-dev.com are intended for accredited investors (pursuant to US rules and regulations) and for persons residing abroad in jurisdictions where securities registration exemptions are available. Securities sold in private placements are not publicly traded, are subject to holding period requirements, and are intended for investors who do not need a liquid investment. Private placement investments are NOT bank deposits (and thus NOT insured by the FDIC or by any other federal governmental agency), are NOT guaranteed by USREM, Inc. (collectively with any affiliates, “USREM”) and MAY lose value. Neither the Securities and Exchange Commission nor any federal or state securities commission or regulatory authority has recommended or approved any investment or the accuracy or completeness of any of the information or materials provided by or through the website.</p>
  <p>This Platform is NOT a stock exchange or public securities exchange, there is no guarantee that liquidity for your investment will be obtained due to, among other possibilities, the absence of willing buyers, nor is there any guarantee that the Platform will continue to operate or remain available to investors. Information displayed on this Platform, including information regarding targeted returns and investment performance, is provided by the sponsor of the investment opportunity and is subject to change. USREM is relying on such sponsor for the information and assumes no liability therefore.</p>
  <p>Past performance is no guarantee of future results. Any historical returns, expected returns, or probability projections are not guaranteed and may not reflect actual future performance.</p>
  <p>All securities involve a high degree of risk and may result in partial or total loss of your investment. USREM is not responsible and shall not be held liable for any failures in performance of sponsors’ private placements.</p>
  <p>Forward-looking statements, hypothetical information or calculations, financial estimates and targeted returns are inherently uncertain. In addition, USREM undertakes no obligation to update such forward-looking statements in the future. Such information should not be used as a primary basis for an investor’s decision to invest. Investment opportunities on the Platform are speculative and involve substantial risk. You should not invest unless you can sustain the risk of loss of capital, including the risk of total loss of capital.</p>
  <p>All secondary trading of holdings on the platform is conducted pursuant to Section 4(a)1, Section 4(a)(2), and Section “4(a)1(1/2)” of the U.S. Securities Act of 1933, as amended, and is open thereunder to accredited investors pursuant to US rules and regulations. In addition, all trades must receive the prior approval of the issuer of the securities, in its sole discretion, who may fail to approve a specific transaction due to additional regulatory considerations and/or limitations applicable to it.</p>
  `
};

export default data;
